import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SchedaCoopEdilizieFormService } from './scheda-coop-edilizie-form.service';
import { CoopEdilizieWarningsService } from './warnings/coop-edilizie.warnings';

@NgModule({
    declarations: [],
    imports: [CommonModule, ReactiveFormsModule],
    providers: [SchedaCoopEdilizieFormService, CoopEdilizieWarningsService],
})
export class SchedaCoopEdilizieFormModule {}
